export default __webpack_public_path__ + "static/signup-thumb-learn-play-bf4be61ff22ef37374d9220a0250ced8.jpg";